<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="part" title="I. THE SHIPMENT">
<p class="shead" id="part1"><a href="#/text/9780802156969_Contents#rpart1"><b>I</b></a></p>
<p class="part"><span class="right_1" epub:type="pagebreak" id="page_1" title="1"><a href="#/text/9780802156969_Contents#rpart1"><b>THE SHIPMENT</b></a></span></p>
<div class="imagec"><img alt="figure" src="images/com.jpg"/></div>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780802156969_Part_1.vue?6839aa66